const features = [
  {
    icon: 'ri-film-line',
    title: '海量高清内容',
    description: '汇聚搞笑、美食、旅游、音乐、科技等20+内容品类，每日更新海量高清短视频，总有一款适合你。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅播放',
    description: '采用先进的视频编解码和CDN加速技术，智能适配网络环境，保证流畅不卡顿的播放体验。',
  },
  {
    icon: 'ri-brush-line',
    title: '强大创作工具箱',
    description: '内置100+滤镜特效、专业级剪辑工具、智能美颜功能，让你轻松创作出高品质短视频内容。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能个性化推荐',
    description: '基于深度学习的推荐算法，精准捕捉你的兴趣偏好，持续推送你真正想看的内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠保障',
    description: '多重内容审核机制，青少年保护模式，数据加密传输，为你的使用安全保驾护航。',
  },
  {
    icon: 'ri-group-line',
    title: '活跃社区互动',
    description: '点赞、评论、分享、私信、直播互动，丰富的社交功能让你与创作者和其他用户紧密连接。',
  },
];

export default function FeatureSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-page">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            核心亮点
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            为什么选择蘑菇视频？
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-base">
            我们致力于打造国内领先的短视频娱乐平台，为每一位用户提供极致体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2.5 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}